import React from 'react'
import { classToFComponent, FCClassContext, Field, FieldHelp, FieldLabel } from 'src/utils/views'
import { FilterExtraAeScope } from '../../tcm_scopes'

import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import { chipSx } from 'src/utils/views'

type FilterExtraAeViewProps = {
    className?: string
    scope: FilterExtraAeScope
}

const DOMAIN_LABEL = ['Todos', 'CNAE principal', 'CNAE secundário']

class FilterExtraAeViewClass implements FCClassContext<FilterExtraAeViewProps> {
    scope!: FilterExtraAeScope

    onSyncState({ scope }: FilterExtraAeViewProps) {
        this.scope = scope
    }

    render({ className, scope }: FilterExtraAeViewProps): React.JSX.Element {
        return (
            <Field className={className}>
                <FieldLabel>Abrangência</FieldLabel>
                <div>
                    <Tooltip title="Clique para alternar a abrangência">
                        <Chip
                            size="small"
                            clickable
                            label={DOMAIN_LABEL[scope.domain] ?? DOMAIN_LABEL[0]}
                            sx={chipSx('blue')}
                            onClick={this.emitOnDomainChanged}
                        />
                    </Tooltip>
                </div>
                <FieldHelp>Alterna entre todos os CNAEs, só o principal e só os secundários.</FieldHelp>
            </Field>
        )
    }

    emitOnDomainChanged = () => {
        this.scope.onChange((this.scope.domain + 1) % 3)
    }
}

export const FilterExtraAeView = classToFComponent(FilterExtraAeViewClass, React)
export default FilterExtraAeView
